import { Component, ComponentRef } from '@angular/core';
import { IModalDialog, IModalDialogButton, IModalDialogOptions } from 'ngx-modal-dialog';
import { AuthenticationService, AlertService } from '../_services/index';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements IModalDialog {
  templateData: any;
  actionButtons: Array<IModalDialogButton>;
  modalData: any;

  private closeDialogSubject: Subject<any>;

  constructor(
    public auth: AuthenticationService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService
  ) {
    this.actionButtons = [{ 
        text: 'Cancel',
        buttonClass: 'ui small button gray-btn float-left no-margin-left',
        onAction: () => true 
      }, { 
        text: 'Submit',
        buttonClass: 'ui small button lightblue-btn',
        onAction: () => {
          this.validateModal(this.modalData);
        }
      }];
  }

  async validateModal(modalData) {
    modalData.error = false;
    this.spinner.show();
    try {
      await this.auth.resetPassword(modalData.email);
      this.spinner.hide();
      this.alertService.success('A password reset link has been sent to the email you provided.', false, 3000);
      this.closeDialogSubject.next('Closed modal');
    } catch (err) {
      this.spinner.hide();
      modalData.error = err;
      return false;
    }
  }

  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<any>>) {
    console.log('Initializing modal Options: ', options);
    this.templateData = options.data.templateData;
    this.closeDialogSubject = options.closeDialogSubject;
    this.modalData = {};
  }
}

